<div class="textblock">
  <div class="container">
    <div class="offset-md-1 offset-lg-2 col-sm-12 col-md-10 col-lg-8">
      <h2 class="textblock__header" [innerHTML]="block.data.text ? block.data.text : block.data.heading"></h2>
      <span class="textblock__text" [outerHTML]="block.data.text"></span>
    </div>
  </div>
</div>
